import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Gets the current frameworks.
 */
export const getFrameworks = factoryAuthService(({ year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/suppliersframework/selector/${year}`)
)

/**
 * Gets the entity report options.
 */
export const getEntityReportOptions = factoryAuthService(({ id }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/descarga/lista/${id}`)
)

/**
 * Gets the initial config.
 */
export const getInitialConfig = factoryAuthService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/configuration/list/concept`)
)

/**
 * To get the last date time when the data were updated.
 */
export const getLastUpdate = factoryAuthService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/fechaActualizacionTabla/getFechaActualizacion`)
)

/**
 * To get the regions options.
 */
export const getRegions = factoryAuthService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/configuration/list/region`)
)
